"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("@apollo/client");function u(e){const n=Object.create(null,{[Symbol.toStringTag]:{value:"Module"}});if(e){for(const s in e)if(s!=="default"){const i=Object.getOwnPropertyDescriptor(e,s);Object.defineProperty(n,s,i.get?i:{enumerable:!0,get:()=>e[s]})}}return n.default=e,Object.freeze(n)}const t=u(a),o={},r=a.gql`
  query userQuery(
    $permissions: [RbacPermissionType!]!
    $withPermissions: Boolean!
  ) {
    user {
      id
      email
      username
      firstName
      lastName
      avatarDefaultColor
      team {
        id
        name
        ssoState
        settings {
          divisionAdminsCanManageUsers
          canFullUserSendInvite
        }
        seatSummary {
          available {
            contributor
            power
          }
        }
      }
      teamMembership {
        id
        isEnterprise
        isAdmin
        isDivisionAdmin
        memberType
      }
      language {
        id
        code
      }
      package {
        id
        canonicalName
        isAnnual
      }
      features {
        liteLibraryEnabled
        plansBenchmarksEnabled
        powerCasualEnabled
        loggedInHomePage
        teamsEnabled
        workgroupsEnabled
        adminDashboardEnabled
        offlineEnterpriseEnabled
        teamAudienceCreditsEnabled
        audienceCreditPoolsEnabled
        auditLogsEnabled
        divisionsEnabled
        deiReporting
      }
      preferences {
        paidBenchmarksEnabled
        hasSeenLIHPWelcomeModal
        newHomePageEnabled
      }
      linkedIdentities {
        totalCount
      }
      permissions
      dataCenterCode
    }
    rbacPermissions(permissions: $permissions) @include(if: $withPermissions) {
      permission
      isAuthorized
    }
  }
`;function l(e){const n={...o,...e};return t.useQuery(r,n)}function d(e){const n={...o,...e};return t.useLazyQuery(r,n)}exports.UserQueryDocument=r;exports.useUserQueryLazyQuery=d;exports.useUserQueryQuery=l;
